import script from "./PonPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PonPopup.vue?vue&type=script&setup=true&lang=js"

import "./PonPopup.vue?vue&type=style&index=0&id=496b2884&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496b2884"]])

export default __exports__